import { useState, useCallback } from 'react';

/**
 * Hook für Grid-Snap Einstellungen.
 * Verwaltet ob Grid-Snap aktiv ist und die Rastergröße.
 */
export function useGridSettings(initialSnap = true, initialSize = 1000) {
  const [gridSnap, setGridSnap] = useState(initialSnap);
  const [gridSize, setGridSize] = useState(initialSize); // in mm

  const toggleGridSnap = useCallback(() => {
    setGridSnap(prev => !prev);
  }, []);

  const enableGridSnap = useCallback(() => {
    setGridSnap(true);
  }, []);

  const disableGridSnap = useCallback(() => {
    setGridSnap(false);
  }, []);

  // Vordefinierte Grid-Größen
  const gridSizePresets = [
    { label: '5mm', value: 5 },
    { label: '10mm', value: 10 },
    { label: '25mm', value: 25 },
    { label: '50mm', value: 50 },
    { label: '100mm', value: 100 },
    { label: '250mm', value: 250 },
    { label: '500mm', value: 500 },
    { label: '1m', value: 1000 },
  ];

  return {
    gridSnap,
    gridSize,
    setGridSnap,
    setGridSize,
    toggleGridSnap,
    enableGridSnap,
    disableGridSnap,
    gridSizePresets,
  };
}

export default useGridSettings;
